import { render, staticRenderFns } from "./VerticalAxis.vue?vue&type=template&id=045f76c1&"
import script from "./VerticalAxis.vue?vue&type=script&lang=js&"
export * from "./VerticalAxis.vue?vue&type=script&lang=js&"
import style0 from "./VerticalAxis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VerticalAxis.vue"
export default component.exports